module.exports = __webpack_public_path__ + "4d8ce97c4ffcea88fc89623a7f358848.pdf";